/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable radix */
/* eslint-disable prettier/prettier */
import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";

const InnerContainer = styled.div`
  top: 10%;
  left: 2%;
  z-index: 99;
  width: 70%;
`;
const TimerContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  gap: 10px;
`;
const GameIdLabel = styled.span`
  font-weight: 500;
  font-size: 16px;
  line-height: 1.2;
  color: ${(props) => props.theme.colors.black};
  white-space: nowrap;
  margin-left: 10px;
`;
const TimeUnit = styled.span`
  font-weight: 500;
  font-size: 19px;
  line-height: 22px;
  line-height: 49px;
  color: ${(props) => props.theme.colors.black};
`;

export default function Timer({
  clearTimer,
  toggleClearTimer,
  timeSeconds,
  setTimeSeconds,
  hasBeenMadeRestartGame,
  setHasBeenMadeRestartGame,
  toggleResetTimer,
  resetTimer,
  isGamePaused, // not the planning pause, pausing the hole game.
  setLocalTimerOfPreviousGame,
  localTimerOfPreviousGame,
  pauseForPlanningTimer,
  planningTimerBaselineRev = 0,
  updatePlanningTimer,
  isGameStarted,
  gameStartTime,
  totalTimeoutDuration,
  isGamePausedRef,
  gameId,
}) {
  const [elapsed, setElapsed] = useState(0);
  const [planningElapsed, setPlanningElapsed] = useState(0);
  const animationRef = useRef();

  useEffect(() => {
    if (!planningTimerBaselineRev) return;
    const sec =
      typeof pauseForPlanningTimer === "number" ? pauseForPlanningTimer : 0;
    const nextMs = Math.max(0, Math.round(sec * 1000));
    setPlanningElapsed(nextMs);
  }, [planningTimerBaselineRev, pauseForPlanningTimer]);

  useEffect(() => {
    let lastTime = null;
    let planningCounter = 0;

    function updateAnimation() {
      const currentTime = performance.now();
      if (resetTimer) {
        setElapsed(0);
        setPlanningElapsed(0);
        toggleResetTimer(false);
      }
      if (localTimerOfPreviousGame != 0) {
        // spoused to work with the restore previous game....
        // if localTimerOfPreviousGame != 0 means player returned from previous game and has already timer
        setElapsed(localTimerOfPreviousGame * 1000); // Convert seconds to milliseconds
        setTimeSeconds(localTimerOfPreviousGame);
        setLocalTimerOfPreviousGame(0);
        // we need to implement planningElapsed in this function !!
      }
      if (lastTime !== null && !isGamePaused && isGamePausedRef.current != true) {
        // to update the normal timer
        setElapsed(() => performance.now() - gameStartTime.current - totalTimeoutDuration.current);
        setTimeSeconds(((performance.now() - gameStartTime.current - totalTimeoutDuration.current) / 1000).toFixed(0));
      }
      // Only count toward the pre-start planning clock before the game officially starts.
      // In-game "pause for planning" must not inflate the pre-start planning metric.
      if (lastTime !== null && !isGamePaused && !isGameStarted) {
        // to update the planning time timer
        const delta = currentTime - lastTime;
        planningCounter += delta;
        if (planningCounter >= 1000) {
          setPlanningElapsed((prevElapsed) => {
            const next = prevElapsed + 1000;
            updatePlanningTimer(next / 1000);
            return next;
          });
          planningCounter = 0;
        }
      }
      lastTime = currentTime;
      animationRef.current = requestAnimationFrame(updateAnimation);
    }

    animationRef.current = requestAnimationFrame(updateAnimation);
    return () => cancelAnimationFrame(animationRef.current);
  }, [
    isGamePaused,
    resetTimer,
    localTimerOfPreviousGame,
    hasBeenMadeRestartGame,
    timeSeconds,
    elapsed,
    planningElapsed,
    setHasBeenMadeRestartGame,
    isGameStarted,
    pauseForPlanningTimer,
  ]);

  function formatTime(milliseconds) {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  }

  return (
    <InnerContainer>
      <TimerContainer>
        <TimeUnit>{formatTime(elapsed)}</TimeUnit>
        {gameId != null && gameId !== "" && (
          <GameIdLabel>Game ID: {gameId}</GameIdLabel>
        )}
      </TimerContainer>
    </InnerContainer>
  );
}
